export const getTableNames = (siccMember, settings, tableName) => {
  let addSicc = siccMember
    ? '-' + siccMember.substring(0, siccMember.length - 2)
    : '';
  if (settings.customTable === 'raptor' || settings.customTable === 'rdo') {
    return tableName + addSicc;
  }
  return tableName + addSicc;
};
